
<app-loading-panel [isLoading]="userMessagesIndicationService.isLoading" [size]="'small'" ></app-loading-panel>


    <kendo-badge-container (click)="goToMessagesList()" *ngIf="!userMessagesIndicationService.isLoading" class="pointer"  title="{{'claims-center.claimMessages.userMessages' | translate}}">
        <img src="./assets/img/portal_message.png" [width]="32" alt="portal-message"/>
    
        <ng-container *ngIf="userPriorityMessagesCount$ | async; let priorityCount">
            <kendo-badge size="small" themeColor="error" title="{{'claims-center.claimMessages.isPriority' | translate}}"
                [position]="'inside'" [align]="{ vertical: 'top', horizontal: 'end' }" >
               {{priorityCount}}
           </kendo-badge>
        </ng-container>

        <ng-container *ngIf="userMessagesCount$ | async; let userMessagesCount">
            <kendo-badge size="small" themeColor="warning"
                [position]="'inside'" [align]="{ vertical: 'bottom', horizontal: 'end' }" >
               {{userMessagesCount}}
           </kendo-badge>
        </ng-container>
      
    </kendo-badge-container>


